import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'hideUsdIso'
})
export class HideUsdIsoPipe implements PipeTransform {
  UsdIso = 'USD';

  transform(value: any, ...args: unknown[]): unknown {
    if (!value || value.toUpperCase() === this.UsdIso) {
      return '';
    }
    return value;
  }
}
